<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<app-logo-card-page [style]="style">

    <ng-container [ngSwitch]="state | async">

        <mat-spinner *ngSwitchCase="ComponentState.wait"></mat-spinner>

        <app-download-cigent *ngSwitchCase="ComponentState.download"
                             [softwareVersion]="softwareVersion"
                             [subscription]="subscription"
                             [email]="formGroup.value.email">
        </app-download-cigent>

        <div *ngSwitchCase="ComponentState.verify">
            <h1>{{'CREATE_ACCOUNT' | translate}}</h1>
            <p>{{'SUB_VERIFY_CODE' | translate}}</p>
            <p>{{'EV_DESC' | translate}}</p>
            <p>{{'EV_SENT' | translate}} {{email.value}}</p>
            <form [formGroup]="codeFormGroup" (ngSubmit)="onCodeSubmit()">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'EV_CODE' | translate}}</mat-label>
                        <input appAutofocus matInput type="text" formControlName="code" maxlength="6">
                        <mat-error *ngIf="firstName?.errors?.required">{{'ADU_FIRST_REQ' | translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-bar">
                    <button id="resend-code" mat-raised-button (click)="onCodeResend()" type="button">{{'EV_RESEND' | translate}}</button>
                    <button id="verify-code" mat-raised-button color="primary" type="submit" [disabled]="!codeFormGroup.valid">{{'EV_SUBMIT' | translate}}</button>
                </div>
            </form>
            <span class="terms-of-use">
                  {{'DIV_TOUA' | translate}}
                  <a href="https://www.cigent.com/terms" target="_blank" rel="noopener noreferrer">{{'DIV_TOUB' | translate}}</a>
                    <span>&nbsp;{{'SUB_AND' | translate}}&nbsp;</span>
                  <a href="https://www.cigent.com/policies" target="_blank" rel="noopener noreferrer">{{'DIV_TOUD' | translate}}</a>.
            </span>
        </div>

        <div class="form-wrapper" *ngSwitchCase="ComponentState.form">
            <h1>{{'CREATE_ACCOUNT' | translate}}</h1>
            <h2>{{'PLUS_TRIAL_TITLE' | translate}}</h2>
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'FIRST' | translate}}</mat-label>
                        <input matInput type="text" formControlName="firstName" maxlength="255">
                        <mat-error *ngIf="firstName?.errors?.required">{{'ADU_FIRST_REQ' | translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'LAST' | translate}}</mat-label>
                        <input matInput type="text" formControlName="lastName" maxlength="255">
                        <mat-error *ngIf="lastName?.errors?.required">{{'ADU_LAST_REQ' | translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'EO_EMAIL' | translate}}</mat-label>
                        <input matInput type="text" formControlName="email">
                        <mat-error *ngIf="email?.errors?.required">{{'ADU_EMAIL_REQ' | translate}}</mat-error>
                        <mat-error *ngIf="email?.errors?.pattern">{{'ADU_EMAIL_VALID' | translate}}</mat-error>
<!--                        <mat-error *ngIf="email?.errors?.exists">{{'EPU_EMAIL_EXISTS' | translate}}</mat-error>-->
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'ADO_COMPANY' | translate}}</mat-label>
                        <input matInput type="text" formControlName="company" maxlength="255">
                        <mat-error *ngIf="company?.errors?.required">{{'COMPANY_NAME_REQ' | translate}}</mat-error>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'LI_PASSWORD' | translate}}</mat-label>
                        <span style="display: flex;">
                          <input matInput type="password" formControlName="password" maxlength="50"
                                id="newPassInput"
                                (capsLock)="onCapsLockNewChanged($event)"
                                (focus)="passwordFocus($event.target?.id)"
                                (blur)="passwordBlur()"
                                (input)="tooltipNew?.show()">
                          @if (capsOnNew) {
                            <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                    #tooltipNew="matTooltip"
                                    matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                            </mat-icon>
                          }
                        </span>
                        <mat-error *ngIf="password?.errors?.required">{{'ADU_PASS_REQ' | translate}}</mat-error>
                        <mat-error *ngIf="password?.errors?.containsPipeSymbol">{{'PW_ERROR_CONTAINS_PIPE' | translate}}</mat-error>
                        <mat-error *ngIf="password?.errors?.complexity">{{'PW_ERROR_CAT' | translate}}</mat-error>
                        <mat-error *ngIf="password?.errors?.minlength">{{'PW_USE_LONG_LEN' | translate}}</mat-error>
                    </mat-form-field>
                    <span class="password-requirements-icon" (click)="showPasswordRequirements()">
                      <span class="mdi mdi-help-circle-outline help-icon" aria-hidden="true"></span>
                    </span>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'DIV_CONF_PW' | translate}}</mat-label>
                        <span style="display: flex;">
                          <input matInput type="password" formControlName="confirmPassword" maxlength="50"
                                id="confirmPassInput"
                                (capsLock)="onCapsLockConfirmChanged($event)"
                                (focus)="passwordFocus($event.target?.id)"
                                (blur)="passwordBlur()"
                                (input)="tooltipConfirm?.show()">
                        @if (capsOnConfirm) {
                          <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                    #tooltipConfirm="matTooltip" matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}"
                                    matTooltipPosition="right">
                          </mat-icon>
                        }
                      </span>
                        <mat-error *ngIf="confirmPassword?.errors?.required">{{'ADU_PASS_REQ' | translate}}</mat-error>
                        <mat-error *ngIf="confirmPassword?.errors?.mustMatch">{{'SUB_PASS_MATCH' | translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="button-bar">
                    <button id="proceed" mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid">{{'PROCEED' | translate}}</button>
                </div>
            </form>
            <p class="all-fields-required">* {{'ALL_FIELDS_REQUIRED' | translate}}</p>
        </div>

    </ng-container>
</app-logo-card-page>
